module.exports = __webpack_public_path__ + "static/media/xano.15f41909.svg";